import { InjectionToken } from "@angular/core";

export interface PendoConfig {
    apiKey: string;
}

export const PENDO_CONFIG = new InjectionToken<PendoConfig>("PENDO_CONFIG");
